import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#0F67AE",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.333",
      "clip-path": "url(#a)"
    }, [
      _createElementVNode("path", { d: "M4.667 7h18.666M4.667 14h18.666M4.667 21h18.666" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h28v28H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }